import { jsPDF } from "jspdf";

const formatCertificateId = () => {
  const year = new Date().getFullYear();
  const randomId = Math.floor(100000 + Math.random() * 900000);
  return `INV-${year}-${randomId}`;
};

const formatIssueDate = () =>
  new Date().toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

export const generateCertificatePDF = (user, examTitle, averageScore) => {
  const doc = new jsPDF("landscape", "mm", "a4");
  const candidateName = `${user.firstName || ""} ${user.lastName || ""}`.trim();
  const certificateId = formatCertificateId();
  const issueDate = formatIssueDate();
  const scoreText = `${averageScore}%`;

  doc.setFillColor(248, 251, 255);
  doc.rect(0, 0, 297, 210, "F");

  doc.setDrawColor(26, 43, 76);
  doc.setLineWidth(2);
  doc.rect(10, 10, 277, 190);
  doc.setDrawColor(37, 99, 235);
  doc.setLineWidth(0.7);
  doc.rect(15, 15, 267, 180);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(24);
  doc.setTextColor(26, 43, 76);
  doc.text("CERTIFICATE OF ACHIEVEMENT", 148.5, 32, { align: "center" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);
  doc.setTextColor(71, 85, 105);
  doc.text("This is to certify that", 148.5, 48, { align: "center" });

  doc.setFont("helvetica", "bold");
  doc.setFontSize(27);
  doc.setTextColor(15, 23, 42);
  doc.text(candidateName || "Candidate", 148.5, 64, { align: "center" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);
  doc.setTextColor(71, 85, 105);
  doc.text("has successfully completed the", 148.5, 78, { align: "center" });

  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.setTextColor(37, 99, 235);
  doc.text(examTitle || "Examination", 148.5, 92, { align: "center" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);
  doc.setTextColor(71, 85, 105);
  doc.text("conducted by", 148.5, 105, { align: "center" });

  doc.setFont("helvetica", "bold");
  doc.setFontSize(21);
  doc.setTextColor(26, 43, 76);
  doc.text("InventraLabs", 148.5, 118, { align: "center" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.setTextColor(51, 65, 85);
  const achievementText = [
    `with an overall score of ${scoreText}.`,
    "The candidate has successfully met the minimum qualifying criteria by achieving more than 50% average score in the examination assessment.",
    "This certificate is awarded in recognition of the candidate's knowledge, dedication, and successful completion of the program.",
  ];
  doc.text(achievementText, 148.5, 133, { align: "center", maxWidth: 235, lineHeightFactor: 1.45 });

  doc.setDrawColor(219, 234, 254);
  doc.line(32, 160, 265, 160);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.setTextColor(15, 23, 42);
  doc.text("Certificate Details", 38, 170);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9.5);
  doc.setTextColor(71, 85, 105);
  doc.text(`Certificate ID: ${certificateId}`, 38, 178);
  doc.text(`Date of Issue: ${issueDate}`, 38, 185);
  doc.text("Mode: Online Assessment", 38, 192);
  doc.text("Status: Passed", 38, 199);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.setTextColor(15, 23, 42);
  doc.text("Digitally Signed By:", 194, 170);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text("InventraLabs Certification Authority", 194, 180);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9.5);
  doc.setTextColor(71, 85, 105);
  doc.text("Authorized Signatory", 194, 188);
  doc.text("[Digital Signature Placeholder]", 194, 196);

  return doc;
};

export const viewCertificate = (user, examTitle, averageScore, setCertificateUrl, setShowCertificate) => {
  const doc = generateCertificatePDF(user, examTitle, averageScore);
  setCertificateUrl(doc.output("bloburl"));
  setShowCertificate(true);
};

export const downloadCertificate = (user, examTitle, averageScore) => {
  const doc = generateCertificatePDF(user, examTitle, averageScore);
  doc.save(`${examTitle || "InventraLabs"}_certificate.pdf`);
};
